const Alert = () => {
  return (
    <>
      <div>1</div>
      <div>2</div>
    </>
  );
};

export default Alert;
